import Utils from './';
import extend from 'extend';

function rename(o, oldName, newName) {
  if (o && o[oldName]) {
    Object.defineProperty(o, newName, Object.getOwnPropertyDescriptor(o, oldName));
    delete o[oldName];
  }
}

export default class ObjectTransform {
  constructor(obj) {
    this.obj = extend(true, {}, obj);
  }

  renameProperty(oldName, newName, path) {
    if (oldName !== newName) {
      let o = path ? Utils.getSafely(this.obj, path) : this.obj;
      rename(o, oldName, newName);
    }
  }

  renamePropertyForEach(oldName, newName, path) {
    if (oldName !== newName) {
      let arr = Utils.getSafely(this.obj, path);
      if (arr instanceof Array) {
        arr.forEach((item) => rename(item, oldName, newName));
      }
    }
  }

  get() {
    return extend(true, {}, this.obj);
  }
}



// WEBPACK FOOTER //
// ./client/utils/ObjectTransform.js